import React from "react";
import { Typography } from "@mui/material";
import StyledNameMail from "./styles";

const NameMail = ({ name, email }) => {
  return (
    <StyledNameMail>
      <div className="nameMail-cont">
        {name && <Typography variant="body2">{name}</Typography>}
        {email && <Typography variant="caption">{email}</Typography>}
      </div>
    </StyledNameMail>
  );
};

export default NameMail;
